/*
 * Cookie banner layout fix for the Pandectes v5 banner (<pandectes-cmp>, Shadow DOM).
 *
 * Why this exists: the banner lives in a shadow root, so theme CSS cannot reach it. Its own stylesheet switches to a
 * two column grid ("text | buttons") as soon as the banner is 500px wide, but the three buttons need ~460px in a
 * single row, so the text column collapses to about 10px: the text wraps one letter per line (it looks empty, with a
 * scroll bar) and the buttons float far to the right. That is what a desktop browser in device emulation at 500-760px
 * (and a large phone in landscape or a small tablet) shows. Under 500px and from ~830px up the app's layout is fine.
 *
 * What it does: adds ONE constructed stylesheet to the banner's shadow root (adoptedStyleSheets, so it survives the
 * app re-rendering the shadow tree). Between 0 and 800px of banner width it keeps text above buttons, puts Accept and
 * Decline side by side with Manage Preferences underneath, makes every target at least 44px tall and the text 14px.
 * It also gives the buttons a 44px minimum height at every width (the app's own buttons are 41px on desktop).
 * Consent behaviour, wording, buttons and Pandectes settings are untouched. The banner stays position:fixed so it
 * never moves page content (no layout shift). No-op when there is no <pandectes-cmp> (stores on the legacy banner).
 */
(function () {
  'use strict';
  var CSS =
    '.dialog.notice .actions button{min-height:44px}' +
    '@container (width < 800px){' +
    '.dialog.notice .inner{font-size:14px}' +
    '.dialog.notice .inner.inner-grid{display:flex;flex-direction:column;gap:12px;padding:16px 16px calc(16px + env(safe-area-inset-bottom,0px))}' +
    '.dialog.notice .inner.inner-grid>div{padding:0}' +
    '.dialog.notice .inner>.header+.body{padding-top:0}' +
    '.dialog.notice .inner.inner-grid>.body{padding:0;align-self:stretch}' +
    '.dialog.notice .actions{width:100%;padding:0}' +
    '.dialog.notice .actions.horizontal{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:stretch;gap:8px}' +
    '.dialog.notice .actions.horizontal .group{display:contents}' +
    '.dialog.notice .actions.horizontal button{flex:1 1 calc(50% - 4px);min-height:44px;min-width:0}' +
    '.dialog.notice .actions.horizontal button.preferences{flex-basis:100%}' +
    '}';
  var done = new WeakSet();
  var sheet = null;

  function apply(host) {
    var root = host.shadowRoot;
    if (!root || done.has(root)) return !!root;
    try {
      if (!sheet) {
        sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
      }
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } catch (e) {
      var s = document.createElement('style');
      s.textContent = CSS;
      root.appendChild(s);
    }
    done.add(root);
    return true;
  }

  function scan() {
    var host = document.querySelector('pandectes-cmp');
    return host ? apply(host) : false;
  }

  if (scan()) return;
  var mo = new MutationObserver(function () {
    if (scan()) mo.disconnect();
  });
  mo.observe(document, { childList: true, subtree: true });
  // The shadow root can be attached a moment after the element is inserted: poll briefly, then give up.
  var tries = 0;
  var iv = setInterval(function () {
    if (scan() || ++tries > 80) {
      clearInterval(iv);
      mo.disconnect();
    }
  }, 250);
})();
